// extracted by mini-css-extract-plugin
export default {"icon":"CartHeaderIcon_icon__pUFxc","count":"CartHeaderIcon_count__vir+V"};